export const NotFoundSite = () => <h3 style={{ margin: 50, textAlign: 'center', fontSize: 40 }}>This site could not be found</h3>;
